import { formatSuccessFeeRate } from '@/libs/utils/format-success-fee-rate';
import { Text, type TextProps } from '@chakra-ui/react';
import type { PlanCollabFee } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';
import { formatCollabFeeFloor } from './format-collab-fee-floor';

/**
 * What a plan charges on collabs: a rate on paid ones with its minimum, and
 * the gifting fee, which is none. Read from the API or the shared fee grid by
 * the caller, never written here.
 */
export const PlanCollabFeeLines = ({
  collabFee,
  giftingFeeBasisPoints,
  currencyCode,
  ...textProps
}: {
  collabFee: PlanCollabFee;
  giftingFeeBasisPoints: number;
  /** The currency the surface prices in; the minimum is a bare figure without it. */
  currencyCode: string | null | undefined;
} & TextProps) => {
  const { t } = useTranslation();
  const locale = t('common.locale');

  return (
    <>
      <Text {...textProps}>
        {t('pricing.plan.collabFee', {
          rate: formatSuccessFeeRate(collabFee.basisPoints, locale),
          floor: formatCollabFeeFloor(collabFee.floorMinorUnits, currencyCode, locale),
        })}
      </Text>
      <Text {...textProps}>
        {giftingFeeBasisPoints === 0
          ? t('pricing.plan.giftingFree')
          : t('pricing.plan.giftingFee', {
              rate: formatSuccessFeeRate(giftingFeeBasisPoints, locale),
            })}
      </Text>
    </>
  );
};
